import { PageOrientationServerString, PdfPageSizeServerString } from '../../app/content/SubscriptionChangeFormatDialog';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ISubscriptionInfo } from '../../ts/models/ISubscriptionInfo';
import { IResourceQuery, ResourceQuery } from '../../ts/resources/ResourceQuery';
import { DeleteSubscriptionsRequest } from '../../ts/ServerApi/requests/DeleteSubscriptionsRequest';
import { GetSubscriptionsRequest } from '../../ts/ServerApi/requests/GetSubscriptionsRequest';
import { ResumeSubscriptionRequest } from '../../ts/ServerApi/requests/ResumeSubscriptionRequest';
import { SetSelfServiceSubscriptionsFrequencyRequest } from '../../ts/ServerApi/requests/SetSelfServiceSubscriptionsFrequencyRequest';
import { SetSubscriptionsDataConditionRequest } from '../../ts/ServerApi/requests/SetSubscriptionDataConditionRequest';
import { SetSubscriptionsFormatRequest } from '../../ts/ServerApi/requests/SetSubscriptionsFormatRequest';
import { SetSubscriptionsFrequencyRequest } from '../../ts/ServerApi/requests/SetSubscriptionsFrequencyRequest';
import { SetSubscriptionsScheduleRequest } from '../../ts/ServerApi/requests/SetSubscriptionsScheduleRequest';
import { SetSubscriptionsSelfServiceScheduleRequest } from '../../ts/ServerApi/requests/SetSubscriptionsSelfServiceSchedule';
import { SetSubscriptionSubjectRequest } from '../../ts/ServerApi/requests/SetSubscriptionSubjectRequest';
import { ISetSelfServiceSubscriptionsFrequencyParams, ISetSubscriptionsFormatParams, ISetSubscriptionsFrequencyParams } from '../../ts/ServerApi/types/actionParams';
import { SelfServiceSchedule } from '../../ts/ServerApi/types/SelfServiceSchedule';
import { SubscriptionDataConditionType } from '../../ts/ServerApi/types/SubscriptionDataCondition';


class SubscriptionsResource {

  private listFetcher = new WebClientListResourceFetcher(GetSubscriptionsRequest, ServerApiMapper.subscriptions);

  private getErrorNotifyingServer() {
    return WebHttpClientWithErrorToastInstance;
  }

  public all(): IResourceQuery<ISubscriptionInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public del(ids: string[]): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteSubscriptionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  resume(id: string): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequest(new ResumeSubscriptionRequest(id));
  }

  setSchedule(ids: string[], scheduleId: string) {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }

  setSelfServiceSchedule(ids: string[], schedule: SelfServiceSchedule) {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) =>
        new SetSubscriptionsSelfServiceScheduleRequest({ ids, schedule })),
      ResultHelper.combineResults);
  }

  changeSubject(id: string, subject: string): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequest(new SetSubscriptionSubjectRequest(id, subject));
  }

  changeDataCondition(ids: string[], dataConditionType: SubscriptionDataConditionType): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequest(
      new SetSubscriptionsDataConditionRequest({ ids, dataConditionType }));
  }

  changeFormat(ids: string[], attachImage: boolean, attachPdf: boolean, pageSizeOption: PdfPageSizeServerString, pageOrientation: PageOrientationServerString): Promise<IResult> {
    const params: ISetSubscriptionsFormatParams = {
      ids: ids,
      attachImage: attachImage,
      attachPdf: attachPdf,
      pageSizeOption: pageSizeOption,
      pageOrientation: pageOrientation
    };
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsFormatRequest(params)),
      ResultHelper.combineResults);
  }

  changeFrequency(ids: string[], scheduleId: string, subscribeOnExtractRefresh: boolean): Promise<IResult> {
    const params: ISetSubscriptionsFrequencyParams = { ids: ids, scheduleId: scheduleId, subscribeOnExtractRefresh: subscribeOnExtractRefresh };
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsFrequencyRequest(params)),
      ResultHelper.combineResults);
  }

  changeSelfServiceSubscriptionsFrequency(ids: string[], schedule: SelfServiceSchedule, subscribeOnExtractRefresh: boolean): Promise<IResult> {
    const params: ISetSelfServiceSubscriptionsFrequencyParams = { ids: ids, schedule: schedule, subscribeOnExtractRefresh: subscribeOnExtractRefresh };
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSelfServiceSubscriptionsFrequencyRequest(params)),
      ResultHelper.combineResults);
  }
}

export const Subscriptions = new SubscriptionsResource;
